export default "__VITE_ASSET__6a881223__"